import React from "react"

import { IconButton } from "@cirrus/ui-kit-ts/src/components/molecules/IconButton"
import { MuiIcon } from "@cirrus/ui-kit-ts/src/components/atoms/MuiIcon"

import { useNavigationService } from "../providers/NavigationService"

export const GoBack = (props) => {
  const { navigate } = useNavigationService()

  return <IconButton
    {...props}
    muiIcon={<MuiIcon.ArrowBack fontSize="small" />}
    sx={{  }}
    title={"Go back"}
    onClick={() => navigate(-1)} />
}
